<template>
  <wh-mobile-list ref="farmWorkRecordList" class="farm-work-record-list" :extra-params="extraParams" data-src="/api/getAgriculturalRecordList">
    <template v-slot="{list}">
      <div v-for="(item, key) in list" :key="key" class="list-item">
        <div class="wh-flex-between">
          <div class="left-content">
            <div class="name">
              <van-tag type="primary" size="large" round>
                {{ item.name }}
              </van-tag>
            </div>
            <van-tag size="medium" class="factory">
              {{ item.factory }}
            </van-tag>
            <div class="specification">
              {{ item.num }} {{ item.unit }}/{{ item.pack }} ({{ item.price }} 元)
            </div>
          </div>
          <div class="right-content">
            <van-tag class="change-count" type="success">
              {{ item.changeCount }} {{ item.unit }}
            </van-tag>
            <div class="cost">
              <span style="color: #333333;font-size: 20px;font-weight: bold;">{{ ((item.changeCount / item.num) * Number(item.price)).toFixed(2) }}</span> 元
            </div>
          </div>
        </div>
        <div class="date">
          {{ formatTime(item.date, 'YYYY-MM-DD') }}
        </div>
      </div>
    </template>
  </wh-mobile-list>
</template>

<script>
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
import { formatTime } from '@/utils/convert/convertTime'

export default {
  name: 'AgriculturalUseRecord',
  components: { WhMobileList },
  props: {
    // 通过绑定 route.query 传递
    landId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      extraParams: {
        farmlandId: this.landId,
        type: 'all',
        recordType: '出库'
      }
    }
  },
  methods: {
    formatTime
  }
}
</script>

<style lang='less' scoped>
.list-item {
  margin: 20px;
  padding: 10px 16px;
  box-shadow: 0 0 10px 0 #ccc;
}
.left-content {
  .factory {
    margin-top: 8px;
  }
  .specification {
    font-size: 14px;
    margin-top: 4px;
  }
}
.right-content {
  text-align: right;
  .cost {
    margin-top: 10px;
  }
}
.date {
  text-align: right;
  font-size: 14px;
  color: #ccc;
}
</style>
